module.exports = __webpack_public_path__ + "assets/img/corner.webp?5ac8ad3b5e72d4c6e98d29a356c89f30";